import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Tab } from 'react-bootstrap'
import { Tabs } from '../../components/Tabs/Tabs'
import { TrackEvent, useTracking } from '../../apps/professional-app/fa/common/tracking'

interface InsightsNavTabsProps {
  active: 'discussions' | 'coaching'
}

export const InsightsNavTabs: FC<InsightsNavTabsProps> = ({ active }) => {
  const navigate = useNavigate()
  const { trackingClient } = useTracking()

  return (
    <Tabs
      id='insights-nav-tabs'
      activeKey={active}
      onSelect={(key) => {
        if (key && key !== active) {
          if (key === 'coaching') {
            trackingClient.track({ eventName: TrackEvent.INSIGHTS_TAB_CHANGED, eventDetails: { tab: key } })
          }
          navigate(key === 'discussions' ? '/insights' : '/insights/coaching')
        }
      }}
    >
      <Tab eventKey='discussions' title='Discussions' />
      <Tab eventKey='coaching' title='Coaching' />
    </Tabs>
  )
}
